var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodSugarMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B3E2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4889 6.81858C20.2267 6.50901 19.7593 6.50901 19.4972 6.81858C18.0038 8.61648 15.9975 11.9265 15.9975 13.9745C15.9975 16.2724 17.7872 18.1299 19.9987 18.1299C22.2103 18.1299 24 16.2724 24 13.9745C23.9886 11.9265 22.0279 8.64029 20.4889 6.81858ZM15.1995 14.0578C15.1995 13.1648 15.5187 12.0813 15.9975 10.9502C16.0887 10.7359 16.0773 10.4977 15.9519 10.2953C14.9829 8.72364 13.9113 7.28294 12.9766 6.22325C12.7144 5.92558 12.2698 5.92558 12.0076 6.22325C9.55668 9.05703 6 14.7484 6 18.2489C6 21.9757 8.9069 25 12.4978 25C15.6555 25 18.3002 22.6544 18.8702 19.5349C18.9272 19.2015 18.7334 18.88 18.4256 18.7728C16.5446 18.0942 15.1995 16.2367 15.1995 14.0578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodSugarMark);
export default __webpack_public_path__ + "static/media/blood_sugar_mark.540d26c0a5604d50a3d7909be15d9ed4.svg";
export { ForwardRef as ReactComponent };